var map = {
	"./account.svg": "ef22",
	"./application.svg": "7f93",
	"./arrow.svg": "b6e4",
	"./data-download.svg": "0dfd",
	"./home-page.svg": "f234",
	"./income.svg": "9e25",
	"./message.svg": "47ff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";